export default "__VITE_ASSET__C2C3XaoH__"